import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=3a064d8b&scoped=true"
import script from "./Routes.vue?vue&type=script&lang=js"
export * from "./Routes.vue?vue&type=script&lang=js"
import style0 from "./Routes.vue?vue&type=style&index=0&id=3a064d8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a064d8b",
  null
  
)

export default component.exports